module.exports = __webpack_public_path__ + "img/SY.3d910ee5.svg";